import { ReactNode } from 'react';

interface NavigationProps {
  children: ReactNode;
  className?: string;
}

const Navigation = ({ children, className = '' }: NavigationProps) => {
  return (
    <div className={className} data-testid="cta-subnav-navigation">
      {children}
    </div>
  );
};

export default Navigation;
